import { Button } from "@/components/ui/button";

interface FinancialPageHeaderProps {
  showCreateButton?: boolean;
  onNewContract?: () => void;
}

export default function FinancialPageHeader({
  showCreateButton = false,
  onNewContract,
}: FinancialPageHeaderProps) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <h2 className="text-lg font-light tracking-tight uppercase text-primary-950 dark:text-white">
        FINANCEIRO
      </h2>
      {showCreateButton && onNewContract && (
        <Button type="button" onClick={onNewContract} className="shrink-0">
          NOVO CONTRATO
        </Button>
      )}
    </div>
  );
}
